import base from "flow/cli/commands/base";
import manifestManager from "flow/utils/manifestManager";
import logger from "flow/logger";
import moduleLoader from "flow/wrappers/moduleLoader";
import ICLICommand from "flow/interfaces/ICLICommand";

let commands: ICLICommand[] = [];
let initialized = false;

function add(command: ICLICommand) {
    // Some commands might be es6 modules
    if ((command as any).default) {
        command = (command as any).default;
    }

    if (getCommand(command.name) !== null) {
        logger.warn("There is already a command with name: " + command.name);
        return;
    }

    if (!command.options) {
        command.options = [];
    }

    if (!command.arguments) {
        command.arguments = [];
    }

    commands.push(command);
}

function addRange(commandArray: ICLICommand[]) {
    for (let i = 0; i < commandArray.length; ++i) {
        add(commandArray[i]);
    }
}

function getCommands() {
    return commands;
}

function getCommand(name: string) {
    for (let i = 0; i < commands.length; ++i) {
        if (commands[i].name === name) {
            return commands[i];
        }
    }
    return null;
}

function getCommandsWhereNameStartsWith(name: string) {
    const matches = [];
    for (let i = 0; i < commands.length; ++i) {
        if (commands[i].name.indexOf(name) === 0) {
            matches.push(commands[i]);
        }
    }
    return matches;
}

function logObjects(...params: any[]) {
    params.forEach(obj => {
        logger.log(obj);
    });
}

function logArray(arr: any[]) {
    for (let i = 0; i < arr.length; i++) {
        logger.log(arr[i]);
    }
}

function init() {
    if (initialized) {
        return Promise.resolve();
    }

    initialized = true;

    addRange(base);
    const commandManifests = manifestManager.getAllCommandScripts();
    const scriptPaths = [];
    for (let i = 0; i < commandManifests.length; ++i) {
        scriptPaths.push(commandManifests[i].scriptPath);
    }

    if (scriptPaths.length === 0) {
        return Promise.resolve();
    }

    const promises = scriptPaths.map(scriptPath =>
        moduleLoader
            .requireSingleAsync(scriptPath)
            .then(add)
            .catch(err => {
                logger.warn("Failed loading command: " + scriptPath);
                if (err.requireModules) {
                    logArray(err.requireModules);
                } else {
                    logObjects(err);
                }
            })
    );

    return Promise.all(promises);
}

function reset() {
    commands = [];
    initialized = false;
}

export default {
    add: add,
    addRange: addRange,
    getCommands: getCommands,
    getCommand: getCommand,
    getCommandsWhereNameStartsWith: getCommandsWhereNameStartsWith,
    init: init,
    reset: reset
};
